import { atomWithReset as stateSegmentWithReset } from 'jotai/utils';
import { Claim, Quote } from '../../../types/Claims';

type PrefetchedClaims = {
  isPrefetchedClaimsLoading: boolean;
  isPrefetchedClaimsError: boolean;
  isPrefetchedClaimsSuccess: boolean; // indicates the success of prefetch api
  preFetchedclaimsList: Claim[];
  quotes: Quote[];
  extendedLibrary: boolean;
};

export const preGenerateCliamsStateSegment =
  stateSegmentWithReset<PrefetchedClaims>({
    isPrefetchedClaimsLoading: false,
    isPrefetchedClaimsError: false,
    isPrefetchedClaimsSuccess: false,
    preFetchedclaimsList: [],
    quotes: [],
    extendedLibrary: false,
  });

preGenerateCliamsStateSegment.debugLabel = 'preGenerateCliamsStateSegment';
